import { createFileRoute, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';
import { createRouteConfig } from '../utils/routeGuard';
import { waitForClerk } from '@/utils/clerk';
import { analytics } from '@/lib/analytics';
import { Header } from '@/components/public/Header';
import { BackLink } from '@/components/public/BackLink';
import { Footer } from '@/components/Footer';
import { Hero } from '@/components/public/pricing/Hero';
import { PricingCards } from '@/components/public/pricing/PricingCards';
import { WhatYouGet } from '@/components/public/pricing/WhatYouGet';
import { FaqPreview } from '@/components/public/pricing/FaqPreview';
import { FinalCTA } from '@/components/public/FinalCTA';

export const Route = createFileRoute('/webPricing')({
  component: WebPricing,
  ...createRouteConfig({
    isPublic: true,
  }),
  beforeLoad: async () => {
    const user = await waitForClerk();
    if (user) {
      let dashboardPath = '/dashboard/feed';
      try {
        const referrerUrl = new URL(document.referrer);
        if (referrerUrl.origin === window.location.origin) {
          const match = referrerUrl.pathname.match(/^(\/dashboard\/[^?#]+)/);
          if (match) dashboardPath = match[1];
        }
      } catch {
        // document.referrer may be empty or unparseable — fall back to default
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      throw redirect({ to: `${dashboardPath}?openSubscription=true` as any, replace: true });
    }
  },
});

function WebPricing() {
  useEffect(() => {
    analytics.track('pricing_viewed');
  }, []);

  return (
    <div className='min-h-screen bg-white text-slate-900'>
      <Header />
      <BackLink />
      <Hero />
      <PricingCards />
      <WhatYouGet />
      <FaqPreview />
      <FinalCTA />
      <Footer />
    </div>
  );
}
